"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _theme = require("../../theme");
var _reactRouterDom = require("react-router-dom");
var _reactAvatar = _interopRequireDefault(require("react-avatar"));
var _system = require("@mui/system");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CardBlock = (0, _system.styled)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    '&:hover': {
      borderLeft: "".concat(theme.palette.primary.main, " solid 5px")
    },
    backgroundColor: _theme.colors.surface,
    borderLeft: "".concat(_theme.colors.surface, " solid 5px"),
    boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
    cursor: 'pointer',
    height: 'auto',
    marginBottom: '8px',
    minHeight: '90px',
    padding: '20px 30px 2px 25px',
    position: 'relative',
    zIndex: 4
  };
});
var CardBlockBottom = (0, _system.styled)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return (0, _defineProperty2["default"])({
    display: 'flex',
    height: 'auto',
    minHeight: '20px',
    paddingTop: '5px',
    width: '100%'
  }, theme.breakpoints.down('500'), {
    justifyContent: 'space-between'
  });
});
var CardBlockLeft = (0, _system.styled)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return (0, _defineProperty2["default"])({
    display: 'flex',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'left',
    verticalAlign: 'middle',
    width: '70%'
  }, theme.breakpoints.down('500'), {
    width: 'unset'
  });
});
var CardBlockRight = (0, _system.styled)("div")(function (_ref6) {
  var theme = _ref6.theme;
  return (0, _defineProperty2["default"])({
    display: 'inline',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'right',
    verticalAlign: 'middle',
    width: '30%'
  }, theme.breakpoints.down('500'), {
    width: '100%'
  });
});
var CardBlockTop = (0, _system.styled)("div")(function (_ref8) {
  var theme = _ref8.theme;
  return (0, _defineProperty2["default"])({
    borderBottom: "1px solid ".concat(_theme.colors.lightGrey),
    display: 'flex',
    height: 'auto',
    minHeight: '65px',
    width: '100%'
  }, theme.breakpoints.down('500'), {
    flexWrap: 'wrap'
  });
});

/**
 * @param status
 * @private
 */
function _getStatusColor(status) {
  var color = _theme.colors.skyBlue;
  if (status.toUpperCase() === 'UNDER REVIEW') {
    color = '#FFA500';
  }
  if (status.toUpperCase() === 'APPROVED') {
    color = _theme.colors.brandGreen;
  }
  if (status.toUpperCase() === 'UNDER REVISION') {
    color = '#EED401';
  }
  return color;
}

/**
 * @param amendments
 * @param isMasterSite
 * @param whitelabel
 * @returns {JSX.Element}
 * @constructor
 */
var AmendmentList = function AmendmentList(_ref10) {
  var amendments = _ref10.amendments,
    isMasterSite = _ref10.isMasterSite,
    whitelabel = _ref10.whitelabel;
  var linkPrefix = isMasterSite ? '/accounts' : '/advisor/account';
  var styles = {
    cardBlockAvatar: {
      display: 'inline',
      height: '100%',
      paddingRight: '20px',
      width: '60px'
    },
    cardBlockLeftBody: {
      display: 'inline',
      height: '100%'
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, amendments.length === 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mediumLarge: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.accountHasNoAmendments)), amendments.map(function (amendment, i) {
    var statusColor = _getStatusColor(amendment.status);
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      key: amendment.amendmentID,
      to: "".concat(linkPrefix, "/").concat(amendment.accountID, "/amendments/").concat(amendment.amendmentID),
      style: {
        textDecoration: 'none'
      }
    }, /*#__PURE__*/_react["default"].createElement(CardBlock, null, /*#__PURE__*/_react["default"].createElement(CardBlockTop, null, /*#__PURE__*/_react["default"].createElement(CardBlockLeft, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.cardBlockAvatar
    }, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], {
      name: "".concat(_i18n["default"].t(_tokens["default"].labels.amendments.amendment), " ").concat(i + 1),
      size: "50",
      textSizeRatio: 2.2,
      round: true,
      fgColor: whitelabel.primaryColor || _theme.colors.skyBlue,
      color: whitelabel.lightColor || _theme.colors.lightBlue
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: styles.cardBlockLeftBody
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      large: true,
      display: "block"
    }, "".concat(_i18n["default"].t(_tokens["default"].labels.amendments.amendment), " ").concat(i + 1)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      display: "inline"
    }, amendment.amendmentID))), /*#__PURE__*/_react["default"].createElement(CardBlockRight, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      bold: true,
      margin: "0 8px 0 0",
      color: statusColor
    }, "\u2022"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      medium: true,
      color: _theme.colors.darkGrey
    }, localizationMaps.fromEnglish("amendmentStatuses", amendment.status.charAt(0).toUpperCase() + amendment.status.slice(1)))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: _theme.colors.darkGrey,
      align: "right",
      small: true,
      display: "block"
    }, "".concat(_i18n["default"].t(_tokens["default"].labels.amendments.agent), ": ").concat(amendment.agent)))), /*#__PURE__*/_react["default"].createElement(CardBlockBottom, null, /*#__PURE__*/_react["default"].createElement(CardBlockLeft, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: _theme.colors.darkGrey,
      tiny: true,
      display: "inline"
    }, "".concat(_i18n["default"].t(_tokens["default"].labels.amendments.updated), ": ").concat(dates.getUTC(amendment.dateUpdated, 'lll', _i18n["default"].locale)))), /*#__PURE__*/_react["default"].createElement(CardBlockRight, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: _theme.colors.darkGrey,
      tiny: true,
      display: "inline"
    }, "".concat(_i18n["default"].t(_tokens["default"].labels.amendments.effective), ": ").concat(dates.getUTC(amendment.effectiveDate, 'll', _i18n["default"].locale)))))));
  }));
};
var _default = exports["default"] = AmendmentList;